import { createApp } from 'vue';

const app = createApp({
    data() {
        return {
            isModalOpen: false,
            modalContentData: null,
        };
    },
    methods: {
        showModal(data, component) {
            this.isModalOpen = true;
            this.modalContentData = {
                data: data,
                component: component,
            };
        },
        closeModal() {
            this.isModalOpen = false;
            this.modalContentData = null;
        }
    }
});

app.component('modal', require('./components/Modal/Modal.vue').default);
app.component('notification', require('./components/Alert/Notification.vue').default);
app.component('dropdown', require('./components/Dropdown/Dropdown.vue').default);
app.component('navbar-dropdown', require('./components/Navbar/NavbarDropdown.vue').default);
app.component('sidebar-collapse', require('./components/Sidebar/SidebarCollapse.vue').default);
app.component('sidebar-item', require('./components/Sidebar/SidebarItem.vue').default);
app.component('delete-form', require('./components/Modal/Form/DeleteForm.vue').default);
app.component('image-upload', require('./components/ImageUpload.vue').default);
app.component('google-map', require('./components/GoogleMap.vue').default);

const vm = app.mount('#app');

window.addEventListener('open-modal', e => {
    if (!vm) return;
    if (!e?.detail) return;
    vm.showModal(e.detail.data, e.detail.component);
});
